var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5346 15.3255L23.8346 12.0255C24.268 11.5921 24.6118 11.0777 24.8463 10.5114C25.0808 9.94523 25.2015 9.33837 25.2015 8.7255C25.2015 8.11263 25.0808 7.50577 24.8463 6.93955C24.6118 6.37334 24.268 5.85886 23.8346 5.4255C23.4013 4.99214 22.8868 4.64837 22.3206 4.41384C21.7544 4.17931 21.1475 4.05859 20.5346 4.05859C19.9218 4.05859 19.3149 4.17931 18.7487 4.41384C18.1825 4.64837 17.668 4.99214 17.2346 5.4255L13.9346 8.7255M8.98464 13.6755L5.68564 16.9755C5.25217 17.4088 4.90831 17.9233 4.67371 18.4895C4.43911 19.0557 4.31836 19.6626 4.31836 20.2755C4.31836 20.8884 4.43911 21.4953 4.67371 22.0615C4.90831 22.6277 5.25217 23.1422 5.68564 23.5755C6.11894 24.009 6.6334 24.3528 7.19962 24.5874C7.76584 24.822 8.37274 24.9428 8.98564 24.9428C9.59854 24.9428 10.2054 24.822 10.7717 24.5874C11.3379 24.3528 11.8523 24.009 12.2856 23.5755L15.5856 20.2755M7.33964 10.3705L4.86564 9.5535M10.6296 7.0805L9.81264 4.6075M22.1796 18.6305L24.6636 19.4475M18.8886 21.9205L19.7056 24.4055M11.4576 17.8025L18.0616 11.1985",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.dd696f687c0f5481170071464e4eb4a8.svg";
export { ForwardRef as ReactComponent };